"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectGuard = exports.prop = exports.props = exports.object = void 0;
var guard_1 = require("../guard");
var lambda_1 = require("../utils/lambda");
// type ResolveProps<Props extends Record<keyof any, Guard<unknown>>> = {
//   [K in keyof Props]: GuardType<Props[K]>
// }
// export type GuardObjectType<Props extends Record<keyof any, Guard<unknown>>> = keyof any extends keyof Props
//   ? {}
//   : {
//       readonly [K in keyof (RP<ResolveProps<Props>> & PP<ResolveProps<Props>>)]: (RP<ResolveProps<Props>> &
//         PP<ResolveProps<Props>>)[K]
//     }
/**
 * Construct a type-guard for an `object`
 * @param options.props the properties of the objects as a record of (key, type-guard)
 * @param options.extendable allow additional keys
 * @param options.mask filter off additional keys when coercing
 */
function object(options) {
    return new ObjectGuard(options);
}
exports.object = object;
/**
 * Construct a type-guard for an `object`
 * @param props the properties of the objects as a record of (key, type-guard)
 */
function props(props, extendable) {
    return object({ extendable: extendable, props: props });
}
exports.props = props;
/**
 * Construct a type-guard for a single-property `object`
 * @param key the key of property
 * @param value the value of property
 */
function prop(key, value, extendable) {
    var _a;
    if (['number', 'string', 'symbol'].includes(typeof key) === false) {
        throw new Error('"key" must a number, string or symbol');
    }
    if (value instanceof guard_1.Guard === false) {
        throw new Error('"value" must an instance of Guard');
    }
    return object({
        extendable: extendable,
        props: (_a = {}, _a[key] = value, _a)
    });
}
exports.prop = prop;
var isIterable = function (value) { return value[Symbol.iterator] !== undefined; };
var ObjectGuard = /** @class */ (function (_super) {
    __extends(ObjectGuard, _super);
    function ObjectGuard(options) {
        var e_1, _a;
        var _this = this;
        var extendable = options.extendable === true; // do not spread options on defaults since { extenable: undefined }
        var mask = options.mask === true;
        var propsGuards = options.props;
        var knownKeys = Object.keys(propsGuards).sort();
        try {
            for (var knownKeys_1 = __values(knownKeys), knownKeys_1_1 = knownKeys_1.next(); !knownKeys_1_1.done; knownKeys_1_1 = knownKeys_1.next()) {
                var knownKey = knownKeys_1_1.value;
                var propGuard = propsGuards[knownKey];
                if (propGuard instanceof guard_1.Guard === false) {
                    throw new Error("\"properties." + knownKey + "\" must an instance of Guard");
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (knownKeys_1_1 && !knownKeys_1_1.done && (_a = knownKeys_1.return)) _a.call(knownKeys_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        _this = _super.call(this, {
            type: 'object',
            coerce: function (path, value, coercer) {
                if (typeof value === 'object' && value !== null && isIterable(value) === false) {
                    var record_1 = value;
                    var coercedProps = Object.entries(propsGuards).reduce(function (acc, _a) {
                        var _b;
                        var _c = __read(_a, 2), key = _c[0], propGuard = _c[1];
                        var coercedPropValue = propGuard.coerce(__spreadArray(__spreadArray([], __read(path), false), [key], false), record_1[key], coercer);
                        if (coercedPropValue === undefined) {
                            return acc;
                        }
                        else {
                            return __assign(__assign({}, acc), (_b = {}, _b[key] = coercedPropValue, _b));
                        }
                    }, {});
                    if (mask === true) {
                        return coercedProps;
                    }
                    else {
                        var unknownProps = Object.fromEntries(Object.entries(value).filter(function (entry) { return knownKeys.includes(entry[0]) === false; }));
                        return __assign(__assign({}, unknownProps), coercedProps);
                    }
                }
                return value;
            },
            validate: function (path, value) {
                var record, unknownKeys, _a, _b, _c, key, propGuard, e_2_1;
                var e_2, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            if (!(typeof value === 'object' && value !== null && isIterable(value) === false)) return [3 /*break*/, 10];
                            record = value;
                            if (!(extendable !== true)) return [3 /*break*/, 2];
                            unknownKeys = Object.entries(record)
                                .filter(function (_a) {
                                var _b = __read(_a, 2), key = _b[0], value = _b[1];
                                return knownKeys.includes(key) === false && value !== undefined;
                            })
                                .map(function (_a) {
                                var _b = __read(_a, 1), key = _b[0];
                                return key;
                            })
                                .sort();
                            if (!(unknownKeys.length !== 0)) return [3 /*break*/, 2];
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'extendable',
                                    setting: extendable,
                                    actual: unknownKeys
                                }];
                        case 1:
                            _e.sent();
                            _e.label = 2;
                        case 2:
                            _e.trys.push([2, 7, 8, 9]);
                            _a = __values(Object.entries(propsGuards)), _b = _a.next();
                            _e.label = 3;
                        case 3:
                            if (!!_b.done) return [3 /*break*/, 6];
                            _c = __read(_b.value, 2), key = _c[0], propGuard = _c[1];
                            return [5 /*yield**/, __values(propGuard.validate(__spreadArray(__spreadArray([], __read(path), false), [key], false), record[key]))];
                        case 4:
                            _e.sent();
                            _e.label = 5;
                        case 5:
                            _b = _a.next();
                            return [3 /*break*/, 3];
                        case 6: return [3 /*break*/, 9];
                        case 7:
                            e_2_1 = _e.sent();
                            e_2 = { error: e_2_1 };
                            return [3 /*break*/, 9];
                        case 8:
                            try {
                                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                            }
                            finally { if (e_2) throw e_2.error; }
                            return [7 /*endfinally*/];
                        case 9: return [3 /*break*/, 12];
                        case 10: return [4 /*yield*/, {
                                path: path,
                                rule: 'type',
                                setting: 'object',
                                actual: value
                            }];
                        case 11:
                            _e.sent();
                            _e.label = 12;
                        case 12: return [2 /*return*/];
                    }
                });
            },
            convert: function (path, value, converter) {
                return Object.entries(value).reduce(function (acc, _a) {
                    var _b;
                    var _c = __read(_a, 2), key = _c[0], propValue = _c[1];
                    var maybePropGuard = propsGuards[key];
                    var convertedValue = maybePropGuard === undefined ? propValue : maybePropGuard.convert(__spreadArray(__spreadArray([], __read(path), false), [key], false), propValue, converter);
                    return __assign(__assign({}, acc), (_b = {}, _b[key] = convertedValue, _b));
                }, {});
            },
            scan: function (path, value, scanner) {
                var record, _a, _b, _c, key, propGuard, propValue, e_3_1;
                var e_3, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            record = value;
                            _e.label = 1;
                        case 1:
                            _e.trys.push([1, 6, 7, 8]);
                            _a = __values(Object.entries(propsGuards)), _b = _a.next();
                            _e.label = 2;
                        case 2:
                            if (!!_b.done) return [3 /*break*/, 5];
                            _c = __read(_b.value, 2), key = _c[0], propGuard = _c[1];
                            propValue = record[key];
                            return [5 /*yield**/, __values(propGuard.scan(__spreadArray(__spreadArray([], __read(path), false), [key], false), propValue, scanner))];
                        case 3:
                            _e.sent();
                            _e.label = 4;
                        case 4:
                            _b = _a.next();
                            return [3 /*break*/, 2];
                        case 5: return [3 /*break*/, 8];
                        case 6:
                            e_3_1 = _e.sent();
                            e_3 = { error: e_3_1 };
                            return [3 /*break*/, 8];
                        case 7:
                            try {
                                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                            }
                            finally { if (e_3) throw e_3.error; }
                            return [7 /*endfinally*/];
                        case 8: return [2 /*return*/];
                    }
                });
            },
            substitute: function (path, replacer) {
                return object(__assign(__assign({}, options), { props: Object.entries(propsGuards).reduce(function (acc, _a) {
                        var _b;
                        var _c = __read(_a, 2), key = _c[0], propGuard = _c[1];
                        return __assign(__assign({}, acc), (_b = {}, _b[key] = propGuard.substitute(__spreadArray(__spreadArray([], __read(path), false), [key], false), replacer), _b));
                    }, {}) }));
            }
        }) || this;
        _this.options = options;
        return _this;
    }
    ObjectGuard.prototype.pick = function (keys, _a) {
        var _b = _a === void 0 ? {} : _a, extendable = _b.extendable, mask = _b.mask;
        return new ObjectGuard({
            props: (0, lambda_1.pick)(this.options.props, keys),
            extendable: extendable,
            mask: mask
        });
    };
    ObjectGuard.prototype.pluck = function (key) {
        return this.options.props[key];
    };
    ObjectGuard.prototype.omit = function (keys, _a) {
        var _b = _a === void 0 ? {} : _a, extendable = _b.extendable, mask = _b.mask;
        return new ObjectGuard({
            props: (0, lambda_1.omit)(this.options.props, keys),
            extendable: extendable,
            mask: mask
        });
    };
    ObjectGuard.prototype.merge = function (_a) {
        var props = _a.props, extendable = _a.extendable, mask = _a.mask;
        var mergedProps = __assign(__assign({}, this.options.props), props);
        return new ObjectGuard({ props: mergedProps, extendable: extendable, mask: mask });
    };
    return ObjectGuard;
}(guard_1.Guard));
exports.ObjectGuard = ObjectGuard;
